import { render, staticRenderFns } from "./popup-cards.vue?vue&type=template&id=30a0e801&scoped=true&"
import script from "./popup-cards.vue?vue&type=script&lang=js&"
export * from "./popup-cards.vue?vue&type=script&lang=js&"
import style0 from "./popup-cards.vue?vue&type=style&index=0&id=30a0e801&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30a0e801",
  null
  
)

export default component.exports